import React, { useEffect } from "react";
import Cookies from "universal-cookie";
import Home from "./containers/Home/Home";
import Header from "./layout/Header/Header";
import Footer from "./layout/Footer/Footer";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PublicRoute from "./containers/PublicRoute/PublicRoute";
import PrivateRoute from "./containers/PrivateRoute/PrivateRoute";
import { WrappedScrollToTop } from "./containers/WrappedScrollToTop/WrappedScrollToTop";

// Guest
import Login from "./containers/Login/Login";
import RegisterOld from "./containers/Register/Register";
import Checkout from "./containers/Checkout/Checkout";
import ForgotPassword from "./containers/ForgotPassword/ForgotPassword";

// User
import Orders from "./containers/Orders/Orders";
import Profile from "./containers/Profile/Profile";
import Address from "./containers/Address/Address";
import OrderSingle from "./containers/Orders/OrderSingle/OrderSingle";

// General
import Archive from "./containers/Archive/Archive";
import Favorites from "./containers/Favorites/Favorites";
import AppWrapper from "./containers/AppWrapper/AppWrapper";
import ContentPage from "./containers/ContentPage/ContentPage";
import SearchContainer from "./containers/SearchContainer/SearchContainer";
import SuccessPage from "./containers/SuccessPage/SuccessPage";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";

import "./styles/_base.scss";
import SingleProductContainer from "./containers/SingleProductContainer/SingleProductContainer";
import GlobalContextProvider from "./contexts/GlobalContext";
import SingleRecipe from "./containers/Recipes/SingleRecipe/SingleRecipe";
import Recipes from "./containers/Recipes/Recipes";
import { CartContextProvider } from "./lib/CartContext/CartContextProvider";
import FailOrder from "./containers/FailOrder/FailOrder";
import { ProductsContextProvider } from "./contexts/ProductsContext/ProductsContextProvider";
import { Categories } from "./containers/Home/Categories/Categories";
import { useResponseDimensions } from "./lib/hooks/useResponseDimensions";

// Admin
import AdminLayout from "./containers/Admin/AdminLayout/AdminLayout";
import AdminLogin from "./containers/Admin/AdminLogin/AdminLogin";
import AdminRoute from "./containers/Admin/AdminRoute/AdminRoute";
import Dashboard from "./containers/Admin/Dashboard/Dashboard";
import Products from "./containers/Admin/Products/Products";
import ProductNew from "./containers/Admin/Products/ProductNew";
import CategoriesAdmin from "./containers/Admin/Categories/Categories";
import CategoryNew from "./containers/Admin/Categories/CategoryNew";
import Brands from "./containers/Admin/Brands/Brands";
import BrandNew from "./containers/Admin/Brands/BrandNew";
import ThemeOptions from "./containers/Admin/ThemeOptions/ThemeOptions";
import AdminOrders from "./containers/Admin/Orders/Orders";
import Customers from "./containers/Admin/Customers/Customers";

function App() {
  const cookies = new Cookies();
  const isTablet = useResponseDimensions().isTablet;

  return (
    <AppWrapper>
      <BrowserRouter>
        <GlobalContextProvider>
          <ProductsContextProvider>
            <CartContextProvider>
              <WrappedScrollToTop>
                <div id="App-container" className="App">
                  <Header />

                  <main id="main-content" className="main_content">
                    {!isTablet && <Categories />}

                    <Switch>
                      <Route path="/kategoria/:pathParam2?" component={Home} />
                      <Route path="/brendi/:pathParam1?" component={Home} />
                      <PublicRoute path="/kyçu" exact component={Login} />
                      <PublicRoute
                        path="/regjistrohu"
                        exact
                        component={RegisterOld}
                      />
                      <Route
                        path="/perditeso-fjalekalimin"
                        exact
                        component={ForgotPassword}
                      />

                      <Route path="/shporta" exact component={Checkout} />
                      {/*<Route*/}
                      {/*  path="/proceso-porosine"*/}
                      {/*  exact*/}
                      {/*  component={Checkout}*/}
                      {/*/>*/}
                      <Route path="/lista" exact component={Favorites} />
                      <Route
                        path={["/recetat", "/informacione/recetat"]}
                        exact
                        component={Recipes}
                      />
                      <Route
                        path="/recetat/:slug"
                        exact
                        component={SingleRecipe}
                      />

                      <PrivateRoute
                        path="/llogaria"
                        exact
                        component={Profile}
                      />
                      <PrivateRoute path="/adresa" exact component={Address} />
                      <PrivateRoute path="/porosite" exact component={Orders} />
                      <PrivateRoute
                        path="/porosite/:id"
                        exact
                        component={OrderSingle}
                      />

                      <Route path="/produktet/:category/" component={Archive} />
                      <Route
                        path="/produkti/:slug"
                        component={SingleProductContainer}
                      />
                      <Route path="/kerko" exact component={SearchContainer} />

                      <Route
                        path="/porosia-sukses/:slug"
                        exact
                        component={SuccessPage}
                      />
                      <Route
                        path="/porosia-pa-sukses/"
                        exact
                        component={FailOrder}
                      />

                      <Route
                        path="/informacione/:slug"
                        exact
                        component={ContentPage}
                      />
                      
                      {/* Admin Routes */}
                      <Route path="/admin/login" exact component={AdminLogin} />
                      <AdminRoute
                        path="/admin"
                        exact
                        component={() => (
                          <AdminLayout>
                            <Dashboard />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/products"
                        exact
                        component={() => (
                          <AdminLayout>
                            <Products />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/products/new"
                        exact
                        component={() => (
                          <AdminLayout>
                            <ProductNew />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/categories"
                        exact
                        component={() => (
                          <AdminLayout>
                            <CategoriesAdmin />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/categories/new"
                        exact
                        component={() => (
                          <AdminLayout>
                            <CategoryNew />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/brands"
                        exact
                        component={() => (
                          <AdminLayout>
                            <Brands />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/brands/new"
                        exact
                        component={() => (
                          <AdminLayout>
                            <BrandNew />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/theme-options"
                        exact
                        component={() => (
                          <AdminLayout>
                            <ThemeOptions />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/orders"
                        exact
                        component={() => (
                          <AdminLayout>
                            <AdminOrders />
                          </AdminLayout>
                        )}
                      />
                      <AdminRoute
                        path="/admin/customers"
                        exact
                        component={() => (
                          <AdminLayout>
                            <Customers />
                          </AdminLayout>
                        )}
                      />
                      
                      <Route path="/" component={Home} />
                    </Switch>
                  </main>
                  <Footer />
                  {!cookies.get("acceptedCookies") && <PrivacyPolicy />}
                </div>
              </WrappedScrollToTop>
            </CartContextProvider>
          </ProductsContextProvider>
        </GlobalContextProvider>
      </BrowserRouter>
    </AppWrapper>
  );
}

export default App;
